import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";

const JUSTIFY_BY_ALIGN = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
} as const;

export const LinkContent = ({
  url,
  children,
  minHeight,
  align,
}: PropsWithChildren<{
  url: string;
  minHeight?: number;
  /**
   * Horizontal alignment of the wrapped content. The inner div is a full-width
   * flex container (for the click target), which otherwise packs content left
   * regardless of the host cell's alignment — right-aligned number cells need
   * this passed through explicitly.
   */
  align?: keyof typeof JUSTIFY_BY_ALIGN;
}>) => {
  const justifyContent = align ? JUSTIFY_BY_ALIGN[align] : "inherit";
  return (
    <Link
      to={url}
      target="_self"
      style={{
        textDecoration: "none",
        color: "inherit",
        display: "flex",
        alignItems: "inherit",
        justifyContent,
        width: "100%",
        height: "100%",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
          minHeight: minHeight ? `${minHeight}px` : undefined,
          display: "flex",
          alignItems: "center",
          justifyContent,
        }}
      >
        {children}
      </div>
    </Link>
  );
};
